import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';


const TextFieldGroup = ({id, isDisabled,field, value, label, error, type, onChange, onKeyUp, placeholder, toolTip, className, selectWidth, onBlur, min, max}) => {
  return (
    <div className={classnames("form-group", {'has-error': error})}>
      {label && <label className="control-label">{label}</label>}
      <div className={classnames("posRel", {"selectWidth" : selectWidth}, {"fieldBg": isDisabled})}>
        <input
          id={id}
          disabled={isDisabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          type={type}
          onKeyUp={onKeyUp}
          name={field}
          placeholder={placeholder}
          className={className ? className : "form-control"}
          min={min}
          max={max}
        />
      </div>
      {toolTip && <a className="Activity-toolTip toolTipCus">
          <span className="tooltiptext">
              {toolTip}
          </span>
      </a>}
      {error && selectWidth && <div><label className="control-label"></label><div className={classnames("posRel ", {"selectWidth" : selectWidth})}><span className="help-block posRel">{error}</span></div></div>}
      {error && !selectWidth && <div><div className={classnames("posRel ", {"selectWidth" : selectWidth})}><span className="help-block posRel">{error}</span></div></div>}
    </div>
  )
}

TextFieldGroup.propTypes ={
  isDisabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string.isRequired,
  placholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func,
  className: PropTypes.string,
  selectWidth: PropTypes.bool,
  onBlur: PropTypes.func
}


TextFieldGroup.defaultProps = {
  type: 'text',
  selectWidth: true
}

export default TextFieldGroup;
